import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { CalendarBookingViewQuestionAnswersBookingFragmentDoc } from './questions/CalendarBookingViewQuestionAnswers/CalendarBookingViewQuestionAnswers.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchBookingQueryVariables = Types.Exact<{
  guid: Types.Scalars['ID']['input'];
}>;


export type FetchBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', guid: string, userGUID: string, startsAt: TimeString, endsAt: TimeString, summary?: string | null, description?: string | null, cancelReason?: Types.BookingCancelReason | null, meetingURL?: string | null, okanekoUser?: { __typename?: 'User', id: string, nickname: string, channel: Types.Channel, karte?: { __typename?: 'Karte', id: string } | null } | null, assignedStaff: { __typename?: 'Staff', guid: string, displayName: string }, questionAnswers: Array<{ __typename?: 'QuestionAnswer', questionText: string, answer: string }> } | null };

export type CancelBookingMutationVariables = Types.Exact<{
  guid: Types.Scalars['ID']['input'];
  cancelReason: Types.BookingCancelReason;
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking?: { __typename?: 'CancelBookingPayload', isSucceeded: boolean } | null };


export const FetchBookingDocument = gql`
    query FetchBooking($guid: ID!) {
  booking(guid: $guid) {
    guid
    userGUID
    startsAt
    endsAt
    summary
    description
    cancelReason
    meetingURL
    okanekoUser {
      id
      nickname
      channel
      karte {
        id
      }
    }
    assignedStaff {
      guid
      displayName
    }
    ...CalendarBookingViewQuestionAnswersBooking
  }
}
    ${CalendarBookingViewQuestionAnswersBookingFragmentDoc}`;

/**
 * __useFetchBookingQuery__
 *
 * To run a query within a Vue component, call `useFetchBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchBookingQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchBookingQuery(variables: FetchBookingQueryVariables | VueCompositionApi.Ref<FetchBookingQueryVariables> | ReactiveFunction<FetchBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchBookingQuery, FetchBookingQueryVariables>(FetchBookingDocument, variables, options);
}
export function useFetchBookingLazyQuery(variables?: FetchBookingQueryVariables | VueCompositionApi.Ref<FetchBookingQueryVariables> | ReactiveFunction<FetchBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchBookingQuery, FetchBookingQueryVariables>(FetchBookingDocument, variables, options);
}
export type FetchBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchBookingQuery, FetchBookingQueryVariables>;
export const CancelBookingDocument = gql`
    mutation CancelBooking($guid: ID!, $cancelReason: BookingCancelReason!) {
  cancelBooking(guid: $guid, cancelReason: $cancelReason) {
    isSucceeded
  }
}
    `;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelBookingMutation({
 *   variables: {
 *     guid: // value for 'guid'
 *     cancelReason: // value for 'cancelReason'
 *   },
 * });
 */
export function useCancelBookingMutation(options: VueApolloComposable.UseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, options);
}
export type CancelBookingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CancelBookingMutation, CancelBookingMutationVariables>;